import React from 'react';

import { useLanguage } from '../context/LanguageContext';

const EbookPoster = () => {
  const { language } = useLanguage();
  // New network image URL (clean, bright library/books theme)
  const bannerImageUrl = "https://picsum.photos/id/24/1920/600"; // Books on shelf

  return (
    <div className="w-full">
      <div 
        className="w-full min-h-[500px] md:min-h-[600px] rounded-none"
        style={{ 
          backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${bannerImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Flex container for centering */}
        <div className="flex items-center justify-center w-full min-h-[500px] md:min-h-[600px]">
          <div className="text-center text-white px-6 py-8 w-full">
            <div className="max-w-6xl mx-auto">
              <h1 className="mb-6 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold drop-shadow-lg">
                📚 eLibrary
              </h1>
              <p className="mb-12 text-lg sm:text-xl md:text-2xl lg:text-3xl drop-shadow-md max-w-3xl mx-auto">
                {language === 'en' ? 'Access ebooks, audiobooks, and resources — anytime, anywhere, on any device.' : 'ഇ-ബുക്കുകളും, ഓഡിയോബുക്കുകളും, മറ്റ് പ്രസിദ്ധീകരണങ്ങളും — എപ്പോഴും , എവിടെയും , എല്ലാ  ഉപകരണത്തിലും ലഭ്യമാക്കുക'}
              </p>
              <button 
  onClick={() => { 
    window.open('https://elibrary.palliativecaremanjeri.com', '_blank'); 
  }} 
  className="btn btn-primary btn-md sm:btn-lg hover:scale-105 transition-transform duration-300 shadow-lg mt-8"
>
  Start Reading
</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EbookPoster;